import axios from 'axios'

/**
 *
 * @param filename 登録したいファイル名
 * @param fileObject ファイルオブジェクト
 * @param uploadPath APIのパス
 */
export const formUploadHelper = async (
  filename: string,
  fileObject: File,
  uploadPath: string,
  overrideFlg: boolean = false
): Promise<string> => {
  try {
    if (!(fileObject instanceof File)) {
      throw new Error('ファイルの読み込みに失敗しました。')
    }
    //拡張子チェック
    const extension = new RegExp('\\.(pdf|jpg|gif|png)$', 'i')
    const acceptedEx = extension.test(filename)
    if (!acceptedEx) {
      throw new Error('ファイル形式は PDF/JPG/GIF/PNG で登録してください。')
    }

    // 上書きを許可しない場合は同じファイル名が存在しないかを一度チェックする
    if (!overrideFlg) {
      const existsFilenames = await axios.get<string[]>(uploadPath)
      if (
        existsFilenames.data.filter(
          existsFilename => filename === existsFilename.replace(`/static${uploadPath}/`, '')
          // s3対応
          // existsFilename => filename === existsFilename.replace(uploadPath, '')
        ).length
      ) {
        throw new Error('そのファイル名は既に使われています。変更してください。')
      }
    }

    const params = new FormData()
    // inputで入力されたファイル名に変更する処理
    const blob = fileObject.slice(0, fileObject.size, filename)
    const newFile = new File([blob], filename, {
      type: 'image/png'
    })
    params.append('file', newFile)

    const { data } = await axios.post<{ path: string }>(uploadPath, params, {
      headers: {
        'Content-Type': 'multipart/form-data'
      }
    })
    return data.path
  } catch (error) {
    throw error
  }
}
